<template>
  <div class="animated fadeIn">
    <div id="snackbar" style="color:red;"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Edit Qr COde</strong>
            <small>Form</small>
          </div>
          <b-form ref="popupform" v-on:submit.prevent.self="updateQR">
            <b-row>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="movie"
                    :options="movieList"
                    track-by="movie_id"
                    label="movie_title"
                    :multiple="false"
                    placeholder="Select Movie"
                    @select="movieSelect"
                    @remove="removeSelect"
                    ref="main_name"
                  ></multiselect>
                  <label style="color:red !important;" v-if="error.movie_error"
                    >please select type</label
                  >
                </b-form-group>
                <div class="image-placeholder">
                  <img :src="`${qr_image}`" width="300" height="300" />
                </div>
              </div>
            </b-row>
            <b-row class="m-2">
              <b-col sm="4">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  @click="UpdateQr"
                >
                  <i class="fa fa-dot-circle-o"></i>
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div></div>
  </div>
</template>

<script>
import QrService from "@/services/QrService";

export default {
  name: "AddPopupPages",
  data() {
    return {
      qr_id: "",
      qr_image: "",
      qrData: [],
      movieList: [],
      movie_title: "",
      movie_id: "",
      movie: "",
      error: {
        movie_error: false
      }
    };
  },
  components: {},
  computed: {},
  watch: {},
  beforeMount() {
    this.qr_id = this.$route.query.qr_id;

    this.GetQrCodeMovieList();
  },
  mounted() {},
  methods: {
    removeSelect(movie) {
      this.movie_id = "";
      this.movie_title = "";
    },
    movieSelect(movie) {
      console.log(movie);
      this.movie_id = movie.movie_id;
      this.movie_title = movie.movie_title;
    },
    UpdateQr() {
      let payload = {
        QRcodeID: this.qr_id,
        movieid: this.movie_id,
        movie_title: this.movie_title
      };
      QrService.UpdateQrCode(payload)
        .then(response => {
          const { data } = response;
          console.log(data);
          if (data.status) {
            this.$toasted.show(data.message);
            this.$router.go(-1);
          } else {
            this.movieList = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getQrCode(item) {
      QrService.GetQrCode(item)
        .then(response => {
          const { data } = response;
          console.log(data);
          if (data.Records.length > 0) {
            this.qrData = data.Records;
            console.log(this.qrData);
            this.qr_image = this.qrData[0].qrcodepath;
            let movie_array = this.movieList.filter(z => {
              return z.movie_id == this.qrData[0].movieid;
            });
            if (movie_array.length > 0) {
              this.movie = movie_array[0];
              this.movieSelect(this.movie);
            }
          } else {
            this.movieList = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    GetQrCodeMovieList() {
      QrService.GetQrCodeMovieList()
        .then(response => {
          const { data } = response;
          if (data.Records.length > 0) {
            this.movieList = data.Records;
          } else {
            this.movieList = [];
          }
          this.getQrCode(this.qr_id);
        })
        .catch(error => {
          console.log(error);
        });
    },
    resetMovie() {},
    updateQR() {}
  },
  updated() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/editQrCode.vue